import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import classNames from 'classnames'; // import dateFormat from 'dateformat';

import { useInterval } from '../reactHooks.js';
import './loading.scss';

function Loading(props) {
  let {
    type = 'normal'
  } = props;
  let [dots, setDots] = useState('');

  let changeDots = () => setDots(dots.length >= 3 ? '' : dots + '.');

  useInterval(changeDots, 300);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(`loadingContainer ${type}`)
  }, /*#__PURE__*/React.createElement("div", {
    className: "loadingDiv"
  }), /*#__PURE__*/React.createElement("div", {
    className: "loadingMessage"
  }, "Loading", dots));
}

export default Loading;